import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';

class EndOfScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            end_of_screen_label: appHelper.getLocaleString("end_of_screen_label"),
        };
        this.getImagePath = this.getImagePath.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                end_of_screen_label: appHelper.getLocaleString("end_of_screen_label"),
            });
        }
    }

    componentDidUpdate() {

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        return (
            <div className={`object-container`} style={{width: `100%`}}>
                <div className="end-of-screen">
                    <div className="content">{this.state.end_of_screen_label}</div>
                </div>
            </div>
        );
    }
}

EndOfScreen.propTypes = {
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

EndOfScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EndOfScreen);


/** WEBPACK FOOTER **
 ** ./src/components/objects/producerNotes/EndOfScreen.js
 **/